import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  dashedBorder: {
    border: "1px dashed",
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  text: {
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
    marginBottom:theme.spacing(2),
    width: "100%"
  },
  largeTextField: {
    borderBottomColor: theme.palette.background.light,
    marginBottom:theme.spacing(2),
    width: "100%",
    height:"50"
  },
  selectField: {
    marginBottom:theme.spacing(2),
    marginRight:theme.spacing(2),
    width: "100%",
  },
  formColumnTexts:{
    width: "100%",
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));
